import React from 'react';
import { injectIntl, FormattedHTMLMessage } from 'react-intl';
import moment from 'moment';
import { connect } from 'react-redux';
import selectors from 'shared/store/selectors';
import './TabContents.scss';

const NDPF = ({
  intl, fullName, nationality, civilId, address,
  isAuthorityToDeal, isPOAholder,
  poaName, poaNationality, poaAddress,applicantId
}) => (
  <div className="tab-contents">
    <header>
      <h5>{intl.formatMessage({ id: 'ndpf.header' })}</h5>
      <h6><FormattedHTMLMessage id="ndpf.subHeader" values={{ crn: 10000+applicantId, portfolioNo: 10000+applicantId+'-N' }} /></h6>
    </header>

    <article>
      <p>
        <FormattedHTMLMessage id="ndpf.p1" values={{ day: moment().format('Do'), month: moment().format('MMMM'), year: moment().year() }} />
      </p>
      <p><FormattedHTMLMessage id="ndpf.p2" /></p>
      <p>
        {(isPOAholder === intl.formatMessage({ id: 'no' })) && (
          <FormattedHTMLMessage
            id="ndpf.p3"
            values={{
              fullName, nationality, civilId, address,
            }}
          />
        )}
        {isAuthorityToDeal === 'legalGuardian' && (
          <FormattedHTMLMessage
            id="ndpf.p3.minor"
            values={{
              fullName, nationality, civilId, address, poaName, poaNationality, poaAddress,
            }}
          />
        )}
        {isPOAholder === intl.formatMessage({ id: 'yes' }) && (
          <FormattedHTMLMessage
            id="ndpf.p3.legalAttorney"
            values={{
              fullName, nationality, civilId, address, poaName, poaNationality, poaAddress,
            }}
          />
        )}
      </p>
      <p><FormattedHTMLMessage id="ndpf.p4" /></p>

      <h5><FormattedHTMLMessage id="ndpf.preamble" /></h5>
      <p><FormattedHTMLMessage id="ndpf.preamble.p1" /></p>
      <p><FormattedHTMLMessage id="ndpf.preamble.p2" /></p>
      <p><FormattedHTMLMessage id="ndpf.preamble.p3" /></p>
      <p><FormattedHTMLMessage id="ndpf.preamble.p4" /></p>

      <h5><FormattedHTMLMessage id="ndpf.article.1" /></h5>
      <p><FormattedHTMLMessage id="ndpf.article.1.p1" /></p>

      <h5><FormattedHTMLMessage id="ndpf.article.2" /></h5>
      <p><FormattedHTMLMessage id="ndpf.article.2.p1" /></p>
      <ol type="A">
        <li><FormattedHTMLMessage id="ndpf.article.2.a" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.2.b" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.2.c" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.2.d" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.2.e" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.2.f" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.2.g" /></li>
      </ol>

      <h5><FormattedHTMLMessage id="ndpf.article.3" /></h5>
      <p><FormattedHTMLMessage id="ndpf.article.3.p1" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.3.p2" /></p>

      <h5><FormattedHTMLMessage id="ndpf.article.4" /></h5>
      <p><FormattedHTMLMessage id="ndpf.article.4.p1" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.4.p2" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.4.p3" /></p>

      <h5><FormattedHTMLMessage id="ndpf.article.5" /></h5>
      <p><FormattedHTMLMessage id="ndpf.article.5.p1" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.5.p2" /></p>

      <h5><FormattedHTMLMessage id="ndpf.article.6" /></h5>
      <p><FormattedHTMLMessage id="ndpf.article.6.p1" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.6.p2" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.6.p3" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.6.p4" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.6.p5" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.6.p6" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.6.p7" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.6.p8" /></p>

      <h5><FormattedHTMLMessage id="ndpf.article.7" /></h5>
      <p><FormattedHTMLMessage id="ndpf.article.7.p1" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.7.p2" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.7.p3" /></p>

      <h5><FormattedHTMLMessage id="ndpf.article.8" /></h5>
      <p><FormattedHTMLMessage id="ndpf.article.8.p1" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.8.p2" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.8.p3" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.8.p4" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.8.p5" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.8.p6" /></p>
      <ol type="a">
        <li><FormattedHTMLMessage id="ndpf.article.8.p6.a" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.8.p6.b" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.8.p6.c" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.8.p6.d" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.8.p6.e" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.8.p6.f" /></li>
      </ol>

      <h5><FormattedHTMLMessage id="ndpf.article.9" /></h5>
      <p><FormattedHTMLMessage id="ndpf.article.9.p1" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.9.p2" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.9.p3" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.9.p4" /></p>
      <ol type="a">
        <li><FormattedHTMLMessage id="ndpf.article.9.p4.a" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.9.p4.b" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.9.p4.c" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.9.p4.d" /></li>
      </ol>
      <p><FormattedHTMLMessage id="ndpf.article.9.p5" /></p>

      <h5><FormattedHTMLMessage id="ndpf.article.10" /></h5>
      <p><FormattedHTMLMessage id="ndpf.article.10.p1" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.10.p2" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.10.p3" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.10.p4" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.10.p5" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.10.p6" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.10.p7" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.10.p8" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.10.p9" /></p>
      <ol type="a">
        <li><FormattedHTMLMessage id="ndpf.article.10.p9.a" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.10.p9.b" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.10.p9.c" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.10.p9.d" /></li>
      </ol>
      <p><FormattedHTMLMessage id="ndpf.article.10.p10" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.10.p11" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.10.p12" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.10.p13" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.10.p14" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.10.p15" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.10.p16" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.10.p17" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.10.p18" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.10.p19" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.10.p20" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.10.p20.a" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.10.p20.b" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.10.p20.c" /></p>

      <h5><FormattedHTMLMessage id="ndpf.article.11" /></h5>
      <p><FormattedHTMLMessage id="ndpf.article.11.p1" /></p>

      <h5><FormattedHTMLMessage id="ndpf.article.12" /></h5>
      <p><FormattedHTMLMessage id="ndpf.article.12.p1" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.12.p2" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.12.p3" /></p>
      <ol type="a">
        <li><FormattedHTMLMessage id="ndpf.article.12.p3.a" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.12.p3.b" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.12.p3.c" /></li>
      </ol>

      <h5><FormattedHTMLMessage id="ndpf.article.13" /></h5>
      <p><FormattedHTMLMessage id="ndpf.article.13.p1" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.13.p2" /></p>

      <h5><FormattedHTMLMessage id="ndpf.article.14" /></h5>
      <p><FormattedHTMLMessage id="ndpf.article.14.p1" /></p>

      <h5><FormattedHTMLMessage id="ndpf.article.15" /></h5>
      <p><FormattedHTMLMessage id="ndpf.article.15.p1" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.15.p2" /></p>
      <ol type="a">
        <li><FormattedHTMLMessage id="ndpf.article.15.p2.a" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.15.p2.b" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.15.p2.c" /></li>
      </ol>
      <p><FormattedHTMLMessage id="ndpf.article.15.p3" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.15.p4" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.15.p5" /></p>

      <h5><FormattedHTMLMessage id="ndpf.article.16" /></h5>
      <p><FormattedHTMLMessage id="ndpf.article.16.p1" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.16.p2" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.16.p3" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.16.p4" /></p>

      <h5><FormattedHTMLMessage id="ndpf.article.17" /></h5>
      <p><FormattedHTMLMessage id="ndpf.article.17.p1" /></p>

      <h5><FormattedHTMLMessage id="ndpf.article.18" /></h5>
      <p><FormattedHTMLMessage id="ndpf.article.18.p1" /></p>

      <h5><FormattedHTMLMessage id="ndpf.article.19" /></h5>
      <p><FormattedHTMLMessage id="ndpf.article.19.p1" /></p>

      <h5><FormattedHTMLMessage id="ndpf.article.20" /></h5>
      <p><FormattedHTMLMessage id="ndpf.article.20.p1" /></p>

      <h5><FormattedHTMLMessage id="ndpf.article.21" /></h5>
      <p><FormattedHTMLMessage id="ndpf.article.21.p1" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.21.p2" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.21.p3" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.21.p4" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.21.p5" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.21.p6" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.21.p7" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.21.p8" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.21.p9" /></p>
      <ul>
        <li><FormattedHTMLMessage id="ndpf.article.21.p9.1" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.21.p9.2" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.21.p9.3" /></li>
        <li><FormattedHTMLMessage id="ndpf.article.21.p9.4" /></li>
      </ul>
      <p><FormattedHTMLMessage id="ndpf.article.21.p10" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.21.p11" /></p>
      <p><FormattedHTMLMessage id="ndpf.article.21.p12" /></p>

      <br />
      <br />

      <p><FormattedHTMLMessage id="ndpf.article.22.p1" /></p>
      <br />
      <p><FormattedHTMLMessage id="ndpf.article.22" /></p>
    </article>
  </div>
);

const mapStateToProps = state => ({
  fullName: selectors.getFullName(state),
  // name: selectors.getAsiName(state),
  // capacity: 'Legal Guardian',
  nationality: selectors.getNationality(state),
  civilId: selectors.getCivilId(state),
  address: selectors.getHomeAddress(state),

  isAuthorityToDeal: selectors.getAsiIsAuthorityToDeal(state),
  isPOAholder: selectors.getAsiIsPOAholder(state),

  poaName: selectors.getAsiName(state),
  poaAddress: selectors.getAsiAddress(state),
  poaNationality: selectors.getAsiNationality(state),
});

export default connect(mapStateToProps, null)(injectIntl(NDPF));
